import React, { useEffect, useState } from "react";
import { Button, Card, Input, Skeleton, EmptyState } from "../../components/ui";
import { Switch } from "../../components/admin/fields";
import { useAsync } from "../../hooks";
import { useToast } from "../../context/ToastContext";
import content from "../../services/api-content";
import "../../styles/content.css";

const HINT = {
  signup_coins: "คอยน์ที่ได้ตอนสมัคร", checkin_coins: "คอยน์เช็คอินรายวัน", checkin_bonus_every: "โบนัสทุก N วันต่อเนื่อง", checkin_bonus_coins: "คอยน์โบนัสเช็คอิน", checkin_bonus_coins_pro: "โบนัสเช็คอิน (VIP ขึ้นไป)",
  referral_inviter_coins: "คอยน์ผู้ชวน", referral_invitee_coins: "คอยน์ผู้ถูกชวน", referral_max_invites: "ชวนได้สูงสุด (คน)", gift_creator_share: "ส่วนแบ่งครีเอเตอร์จากของขวัญ (0-1)",
  char_approval_required: "ตัวละครใหม่ต้องรออนุมัติ", max_chars_per_user: "ตัวละครสูงสุดต่อผู้ใช้", context_messages: "จำนวนข้อความย้อนหลังที่ส่งให้ AI", max_message_len: "ความยาวข้อความสูงสุด",
  topup_require_init: "ต้องผูกรายการเติมเงินก่อนยืนยัน", ai_daily_free_limit: "โควตา AI ช่วยเขียน/ค้นหา (ฟรี) ต่อวัน", announcement: "ประกาศหน้าแรก (ว่าง = ไม่แสดง)",
  coin_per_baht: "เติมกำหนดเอง: คอยน์ต่อ 1 บาท (ฐาน)", custom_topup_min: "ยอดเติมขั้นต่ำ (บาท) ทั้งแพ็กและกำหนดเอง", custom_topup_max: "ยอดเติมกำหนดเองสูงสุด (บาท)",
  coin_bonus_tiers: "ขั้นโบนัสคอยน์ รูปแบบ ยอดบาทขั้นต่ำ:% คั่นจุลภาค เช่น 500:10,1000:20",
  create_credit_price: "ราคาสิทธิ์สร้างตัวละครต่อตัว (บาท)", create_credit_max: "ซื้อสิทธิ์กำหนดเองได้สูงสุดต่อครั้ง (ตัว)",
  create_credit_tiers: "ขั้นส่วนลดสิทธิ์ รูปแบบ จำนวนตัวขั้นต่ำ:% เช่น 5:5,10:10 (แต่ละขั้นเป็นแพ็กสำเร็จรูป)", create_credit_required: "เผยแพร่ตัวละครต้องใช้สิทธิ์ (ปิด = เผยแพร่ฟรี)",
};

export default function AdminSettings() {
  const toast = useToast();
  const { data, loading, error, reload } = useAsync(() => content.admin.settings.get(), []);
  const [vals, setVals] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) setVals(data); }, [data]);
  if (error) return <EmptyState icon="⚠️" title="โหลดตั้งค่าไม่สำเร็จ" action={<Button onClick={reload}>ลองใหม่</Button>}><span className="error-text">{error}</span></EmptyState>;
  if (loading) return <Skeleton height={240} />;
  const changed = Object.keys(vals).filter((k) => JSON.stringify(vals[k]) !== JSON.stringify(data[k]));
  const save = async () => {
    setBusy(true);
    try {
      for (const k of changed) await content.admin.settings.set(k, vals[k]);
      toast(`บันทึก ${changed.length} รายการแล้ว`, "success");
      reload();
    } catch (e) { toast(e.message, "error"); } finally { setBusy(false); }
  };
  const clear = async () => { try { await content.admin.clearCache(); toast("ล้างแคชแล้ว", "success"); } catch (e) { toast(e.message, "error"); } };
  return (
    <div>
      <Card>
        {Object.keys(vals).map((k) => {
          const v = vals[k];
          const set = (nv) => setVals((s) => ({ ...s, [k]: nv }));
          return typeof v === "boolean" ? (
            <div key={k} className="setting-row"><div className="grow"><div className="strong">{HINT[k] || k}</div><div className="faint" style={{ fontSize: 12 }}>{k}</div></div><Switch label={k} checked={v} onChange={set} /></div>
          ) : (
            <div key={k} className="setting-row"><div className="grow"><div className="strong">{HINT[k] || k}</div><div className="faint" style={{ fontSize: 12 }}>{k}</div></div>
              <div style={{ width: k === "announcement" || /tiers$/.test(k) ? 280 : 130 }}><Input aria-label={k} type={typeof v === "number" ? "number" : "text"} step={k === "gift_creator_share" ? "0.05" : undefined} value={v ?? ""} onChange={(e) => set(typeof v === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)} style={{ marginBottom: 0 }} /></div></div>
          );
        })}
      </Card>
      <div className="row mt-16 wrap"><Button variant="primary" onClick={save} disabled={busy || !changed.length}>{busy ? "กำลังบันทึก..." : `บันทึก${changed.length ? ` (${changed.length})` : ""}`}</Button><Button onClick={clear}>ล้างแคชระบบ</Button></div>
    </div>
  );
}
